module.exports = __webpack_public_path__ + "img/pale-blue-left.1a1181d1.svg";